import moment from 'moment-timezone';

// "Cancelled by" line under a cancelled session's status, from the list API's
// session_cancelled_by_* fields and epoch_cancellation_time.

export interface CancelledSession {
  status?: string;
  session_cancelled_by_type?: string;
  session_cancelled_by_name?: string;
  epoch_cancellation_time?: number | null;
}

const ACTOR_LABELS: Record<string, string> = {
  care: 'care',
  teacher: 'teacher',
  student: 'student',
  system: 'system'
};

// Terminal cancel statuses (apis session_cancelled_by.ts); REQUEST_CANCELLATION_* are still pending.
const CANCEL_STATUSES = [
  'CANCELLED',
  'CANCELLED_BY_TEACHER',
  'CANCELLED_BY_STUDENT',
  'NO_SHOW_CANCELLATION_1HOUR',
  'JOINED_BUT_CANCELLED'
];

export const cancelledByLine = (session: CancelledSession, tz: string, format: string): string => {
  if (!session || !CANCEL_STATUSES.includes(session.status || '')) return '';
  const actor = ACTOR_LABELS[session.session_cancelled_by_type || ''];
  const name = (session.session_cancelled_by_name || '').trim();
  const who = actor ? `by ${name ? `${name} (${actor})` : actor}` : '';
  const at = session.epoch_cancellation_time
    ? moment(session.epoch_cancellation_time).tz(tz).format(format)
    : '';
  if (!who && !at) return '';
  return ['Cancelled', who, at ? `on ${at}` : ''].filter(Boolean).join(' ');
};
